"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find");
var _vuex = require("vuex");
var _recommended = require("@/api/recommended");
var _asyncInfo = _interopRequireDefault(require("@/components/async-info"));
var _lodash = _interopRequireDefault(require("lodash"));
var _collectionManage = _interopRequireDefault(require("./components/collection-manage"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CollectionManage: _collectionManage.default,
    AsyncInfo: _asyncInfo.default
  },
  data: function data() {
    return {
      tableData: [],
      totalPage: 1,
      currentPage: 1,
      perPage: 15,
      totalNumber: 0,
      // 总数量
      loading: true,
      theCateId: [],
      selectedCateId: '',
      channel: '',
      manageType: '',
      chooseData: {},
      searchProductId: '' // 搜索产品ID
    };
  },
  filters: {
    getName: function getName(val, theCateId) {
      var result = theCateId.find(function (v) {
        if (v.label === val) {
          return v;
        }
      });
      return result ? result.value : '';
    }
  },
  computed: (0, _vuex.mapState)({
    all_products: function all_products(state) {
      var products = _lodash.default.cloneDeep(state.common.all_products);
      var item = {
        id: 'all',
        name: '全部测算'
      };
      if (products) {
        // 过滤无 app_id 的测算
        products = products.filter(function (item) {
          return !!item.app_id;
        });
        products.unshift(item);
      }
      return products;
    }
  }),
  mounted: function mounted() {
    this.getMap();
    if (!this.all_products) {
      this.getAllProducts();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)({
    getAllProducts: 'common/getAllProducts'
  })), {}, {
    getMap: function getMap() {
      var _this = this;
      (0, _recommended.getSiteResourceMap)().then(function (_ref) {
        var code = _ref.code,
          data = _ref.data;
        if (code === 200) {
          var resultData = data.data;
          var arr1 = [];
          resultData.forEach(function (v) {
            arr1.push({
              value: v.title,
              label: v.key
            });
          });
          _this.theCateId = arr1; // 页面数据
          _this.selectedCateId = arr1[0].label; // 默认选中的页面
          _this.getList();
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    getList: function getList() {
      var _this2 = this;
      if (!this.selectedCateId) {
        this.$message.error('请选择页面');
        return;
      }
      this.loading = true;
      var params = {
        cate_id: this.selectedCateId,
        channel: this.channel,
        app_id: this.searchProductId,
        page: this.currentPage,
        per_page: this.perPage
      };
      (0, _recommended.getSiteResourceList)(params).then(function (_ref2) {
        var code = _ref2.code,
          data = _ref2.data;
        _this2.loading = false;
        if (code === 200) {
          var list = data.list,
            meta = data.meta;
          _this2.tableData = list;
          _this2.totalPage = meta.page.total_page;
          _this2.totalNumber = meta.page.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    onSearch: function onSearch() {
      this.getList();
    },
    onAdd: function onAdd() {
      this.$refs.managePop.dialogVisible = true;
      this.manageType = 'add';
      this.chooseData = {};
    },
    onModify: function onModify(val) {
      this.$refs.managePop.dialogVisible = true;
      this.manageType = 'edit';
      this.chooseData = _lodash.default.cloneDeep(val);
    },
    // 分页
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.getList();
    },
    onCopy: function onCopy() {
      this.$message({
        type: 'success',
        message: '复制成功!',
        duration: 1000
      });
    },
    onSyncIconAndBanner: function onSyncIconAndBanner() {
      this.$refs.asyncInfoPop.dialogVisible = true;
    },
    onError: function onError() {
      this.$message.error('复制失败!');
    }
  })
};